import { render, staticRenderFns } from "./studentManagement.vue?vue&type=template&id=14e5389a&scoped=true&"
import script from "./studentManagement.vue?vue&type=script&lang=js&"
export * from "./studentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e5389a",
  null
  
)

export default component.exports